/**
 * Renders whichever shell dialog is up, and holds the walk-lock while one is.
 *
 * The five hand-rolled scrims (confirm, skid, finder, work orders, routes)
 * became antd Modals; this component is where the surviving four mount. Each
 * dialog conditional-mounts, so closing tears it down immediately - the same
 * lifetime the scrims had.
 */

import { useEffect } from 'react'
import type { HouseBus } from '../../sim/house/model'
import type { Journal } from '../../learn/Journal'
import { acquireWalkLock } from '../input/walkLock'
import { useObservable } from '../state/useObservable'
import { dialogStore } from './dialogStore'
import { SkidDialog } from './SkidDialog'
import { MauDialog } from './MauDialog'
import { ToolFinderDialog } from './ToolFinderDialog'
import { WorkOrdersBoard } from './WorkOrdersBoard'
import { OrderDebrief } from './OrderDebrief'
import { RoutesDialog } from './RoutesDialog'
import { LineDialog } from './LineDialog'
import { FabAuthorDialog } from './FabAuthorDialog'

export function ShellDialogs({ journal, house }: { journal: Journal; house: HouseBus }) {
  const dialog = useObservable(dialogStore.subscribe, () => dialogStore.current)

  // Any open dialog freezes the walk - WASD under a modal walked the student
  // away from the question. One lock here covers all of them.
  useEffect(() => {
    if (!dialog) return
    return acquireWalkLock()
  }, [dialog])

  if (!dialog) return null
  const close = (): void => dialogStore.close()

  switch (dialog.kind) {
    case 'skid':
      return <SkidDialog system={dialog.system} journal={journal} house={house} onClose={close} />
    case 'mau':
      return <MauDialog journal={journal} house={house} onClose={close} />
    case 'finder':
      return <ToolFinderDialog onJump={dialog.onJump} onClose={close} />
    case 'orders':
      return <WorkOrdersBoard onClose={close} />
    case 'orderDebrief':
      return (
        <OrderDebrief
          progress={dialog.progress}
          journal={dialog.journal}
          startIndex={dialog.startIndex}
          onClose={close}
        />
      )
    case 'routes':
      return <RoutesDialog journal={dialog.journal} onClose={close} />
    case 'line':
      return <LineDialog onClose={close} />
    case 'author':
      return <FabAuthorDialog onClose={close} />
  }
}
